module.exports = __webpack_public_path__ + "media/images/icons/twotone/carry-out-29f909a7e4c04833bb3818226c8a01d2.svg";